import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=b0e05018&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=b0e05018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e05018",
  null
  
)

export default component.exports